export default "__VITE_ASSET__ae83d801__"